<template>
	<div>
		<b-breadcrumb>
			<b-breadcrumb-item text="Home" to="/"/>
			<b-breadcrumb-item text="File System" active/>
		</b-breadcrumb>
		<b-container fluid>
			<a-file-system-explorer/>
		</b-container>
	</div>
</template>
<script>

export default {
  name: 'file-system-page',
  data: () => ({
  }),
  methods: {
  },
  created () {
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// FileSystemPage.vue?33f5cff9